import { BillAmountProvider, ProviderDropdownItem } from '@/state/state.types';
import { nanoid } from 'nanoid';

export type BillAmountRow = {
  key: string;
  amountDisplay: string;
  amount: number;
  provider: BillAmountProvider | null;
  isCustomProvider: boolean;
  providerSearchTerm: string;
  errors: {
    amount?: string;
    provider?: string;
  };
};

export const MAX_ROWS = -1;

export const createEmptyRow = (): BillAmountRow => ({
  key: nanoid(),
  amountDisplay: '',
  amount: 0,
  provider: null,
  isCustomProvider: false,
  providerSearchTerm: '',
  errors: {},
});

export const mapDropdownToProvider = (item: ProviderDropdownItem): BillAmountProvider => ({
  name: item.label,
  id: item.value,
  state: item.state_code ?? '',
  city: item.city ?? '',
  s3_key: item.s3_object_key ?? '',
});

export const isProviderDuplicate = (
  rows: BillAmountRow[],
  excludeKey: string,
  provider: BillAmountProvider,
): boolean => {
  return rows.some((row) => {
    if (row.key === excludeKey || !row.provider) return false;
    if (provider.id && row.provider.id) return provider.id === row.provider.id;
    return (
      row.provider.name === provider.name &&
      row.provider.city === provider.city &&
      row.provider.state === provider.state
    );
  });
};
